import QuantityModifier from "@ancon/wildcat-ui/web/orderweb/QuantityModifier";
import "@ancon/wildcat-ui/web/orderweb/QuantityModifier/QuantityModifier.css";
import "@ancon/wildcat-ui/web/orderweb/Button/Button.css";
import "@ancon/wildcat-ui/web/orderweb/BodyText/BodyText.css";

export default QuantityModifier;
